import React from 'react';
import { Link } from 'react-router-dom';
import { withAttSub } from 'decorators/withSub';
import { planCarriersDisplayNames } from 'constants/attCarriers';

const component = ({ sub, backToSub = true, showBackLink = true }) =>
  sub ? (
    <div className="SubNav">
      <h3>
        {sub.first_name} {sub.last_name}{' '}
        {sub.synced_with_att !== undefined && !sub.synced_with_att && (
          <React.Fragment>
            {' '}
            - <span className="text-danger">BYPASSED</span>
          </React.Fragment>
        )}
        {sub &&
          sub.plan &&
          sub.plan.plan_carrier &&
          ['pwg', 'tsp', 'att', 'asp'].includes(sub.plan.plan_carrier) && (
            <React.Fragment>
              {' '}
              -{' '}
              <span className="">
                {planCarriersDisplayNames[sub.plan.plan_carrier]
                  ? planCarriersDisplayNames[sub.plan.plan_carrier]
                  : sub.plan.plan_carrier}
              </span>
            </React.Fragment>
          )}
      </h3>
      <p className="links">
        {showBackLink ? (
          backToSub ? (
            <Link to={`/att/subscriptions/${sub.id}/view`}>
              &larr; Back to Subscription
            </Link>
          ) : (
            <Link to={`/users/${sub.user_profile}/view`}>
              &larr; Back to User
            </Link>
          )
        ) : (
          false
        )}
      </p>
    </div>
  ) : null;

export const SubNav = component;
export default withAttSub(component);
